// removed by extract-text-webpack-plugin
module.exports = {"summaryHeader":"FobTable__summaryHeader___3tWaw","tableWrapper":"FobTable__tableWrapper___--AV7","footerInfo":"FobTable__footerInfo___C247L","fobTable":"FobTable__fobTable___1cVAa","fobValueLow":"FobTable__fobValueLow___13Qay","fobValue":"FobTable__fobValue___3BDvS"};


//////////////////
// WEBPACK FOOTER
// ./src/components/FobTable/FobTable.less
// module id = 1234
// module chunks = 0